import React from 'react';
import { Row, Col, } from 'antd'
import { COLOR, FONT } from '../constants';
import _ from 'lodash';
import useResponsive from '../hooks/useResponsive'
import styled from 'styled-components'
import TNContent from './TNContent';

const TEAM_LIST = {

  upper: [{
    filename: 'team_member_Ryan.jpg',
    name: '>_ RYAN.I _',
    title: 'Shiba9 Guru',
    span: { xs: 24, sm: 24, md: 7, lg: 7 }
  },
  {
    filename: 'team_member_Lucas.jpg',
    name: '>_ LUCAS.M _',
    title: 'Shiba9 Wizard',
    span: { xs: 24, sm: 24, md: 7, lg: 7 }
  }],

  lower: [{
    filename: 'team_member_Toby.jpg',
    name: '>_ TOBY.C _',
    title: 'Shiba9 Tamer',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },
  {
    filename: 'team_member_Joey.jpg',
    name: '>_ JOEY.H _',
    title: 'Shiba9 Communicator',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },
  {
    filename: 'team_member_Zero.jpg',
    name: '>_ ZERO.N _',
    title: 'Shiba9 Magician',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },
  {
    filename: 'team_member_Tim.jpg',
    name: '>_ TIM.C_',
    title: 'Shiba9 Innovator',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },
  {
    filename: 'team_member_Perry.jpg',
    name: '>_ PERRY.T _',
    title: 'Shiba9 Stylist',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },
  {
    filename: 'team_member_Kenneth.jpg',
    name: '>_ KENNETH.W _',
    title: 'Shiba9 Cosmetician',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },
  {
    filename: 'team_member_Kelvin.jpg',
    name: '>_ KELVIN.Y _',
    title: 'Shiba9 Groomer',
    span: { xs: 11, sm: 11, md: 7, lg: 5 }
  },],




}
const TeamMember = () => {
  const { isMobile } = useResponsive();
  return (

    <TNContent maxWidth={1920}>
      <Row justify='center'
        gutter={[0, 24]}
        style={{
          backgroundImage: "url('./assets/team_member_bg.png')",
          backgroundPosition: 'bottom',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          textAlign: 'center',
          paddingTop: 0,
          paddingBottom: 120,
        }}>

        <Col style={{ textAlign: 'center', marginTop: 80 }} span={24}>
          <img src="./assets/primary_star.svg" alt="" style={{ width: 40 }} />
        </Col>
        <Col style={{ textAlign: 'center' }} span={24}><span style={{ ...FONT.h5, color: COLOR.primary }}>
          MEET THE</span></Col>
        <Col style={{ textAlign: 'center', marginBottom: 20 }} span={24}><span style={{ ...FONT.h3, color: COLOR.heading }}>
          TEAM
        </span></Col>
        <Col style={{ textAlign: 'center', marginBottom: 60 }}
          xs={22} sm={22} md={16} lg={12}>

          <Row align='middle' style={
            isMobile ? {
              ...FONT.captionText, color: '#000000',
              border: '4px solid #000000',
              boxShadow: '6px 7px 0px #000000',
              borderRadius: 8,
              background: COLOR.primary,
            } : {
              ...FONT.h6, color: '#000000',
              border: '4px solid #000000',
              boxShadow: '6px 7px 0px #000000',
              borderRadius: 8,
              // height: 54,
              background: COLOR.primary,
            }
          }>
            <Col span={24} style={{ padding: '10px 20px' }} >
              <span >

                Some teams call themselves a family, but we actually are one!
              </span>
            </Col>
          </Row>
        </Col>

        <Col xs={23} sm={23} md={24} lg={22} xl={20}>

          <Row justify="center" style={{ marginBottom: 20 }}>
            {_.map(TEAM_LIST.upper, (item) => {
              return <TeamMemberCard key={item.name} filename={item.filename} name={item.name} title={item.title} span={item.span} />
            })}
          </Row>

          <Row justify="center" gutter={[0, 24]}>
            {_.map(TEAM_LIST.lower, (item) => {
              return <TeamMemberCard key={item.name} filename={item.filename} name={item.name} title={item.title} span={item.span} />
            })}
          </Row>
        </Col>

      </Row>
    </TNContent>
  )
}

const StyledCol = styled(Col)`
margin: 5px;
  &:hover {
    background-color: #000 !important;
    border: 4px solid #000000;
    box-shadow: 6px 7px 0px #000000;
    transition: all 0.5s;
    border-radius: 8px;
    .card {
      border-radius: 8px
    }
  }
  transition: all 0.5s;
  border-radius: 8px;
  border: 4px solid #fff;
`

const TeamMemberCard = ({ name, title, filename, span }) => {
  const { isMobile } = useResponsive();
  return (
    <StyledCol {...span}
      style={isMobile ? { margin: 5, height: '100%' } : { margin: 10, height: '100%' }} >
      <Row justify='center' className='card' style={{ background: '#fff', borderRadius: 4, padding: 8, margin: 0 }}>
        <Col style={{ textAlign: 'center', }}>
          <img src={`./assets/${filename}`} alt="" style={{ width: '100%', }} />
        </Col>

        <Col style={{ textAlign: 'center', marginTop: 20 }}
          span={23}>
          <span style={{ ...FONT.h6, color: '#1A1A1A' }}>
            {name}</span>
        </Col>


        <Col style={{ textAlign: 'center', marginBottom: 10 }}
          xs={16} sm={16} md={24} lg={24} >
          <span style={isMobile ? { ...FONT.captionText, color: '#1A1A1A' } : { ...FONT.h6, color: '#1A1A1A' }}>
            {title}
          </span>
        </Col>
      </Row>

    </StyledCol>
  )
}

export default TeamMember;